import gql from 'graphql-tag';

const CAMPAIGN_ORDER_TRANSACTIONS_DETAILS = gql`
  query campaignOrderTransactionsDetails($id: ID!) {
    campaignOrderTransactionReports(where: { analytics: { campaignOrder: { id: $id } } }) {
      id
      transactions
      revenue
      spend
      customers
      roas
      transactionsByCampaign {
        id
        adProviderId
        campaignName
        cpm
        transactions
        revenue
        spend
        impressions
        roas
        customers
        byDate {
          date
          transactions
          revenue
          spend
          impressions
        }
      }
    }
  }
`;

export default CAMPAIGN_ORDER_TRANSACTIONS_DETAILS;
